import e from "./generateUtilityClasses.mjs";
const l = e("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
export {
  l as default
};
//# sourceMappingURL=touchRippleClasses.mjs.map
